module.exports = __webpack_public_path__ + "da4e542cfd18f35dee4412d685e0f778.png";